import { Phone, MessageCircle } from "lucide-react";
import { telHref, waHref } from "../lib/business";

export const FloatingDock = () => {
    return (
        <div
            data-testid="floating-dock"
            className="fixed bottom-5 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 rounded-full border border-slate-200 bg-white/85 backdrop-blur-xl px-2 py-2 shadow-[0_20px_50px_-20px_rgba(15,23,42,0.4)]"
        >
            <a
                href={telHref}
                data-testid="float-call-btn"
                className="relative inline-flex items-center gap-2 rounded-full bg-[#FF3B30] hover:bg-[#E6352B] text-white px-4 sm:px-5 py-2.5 text-sm font-bold transition-all hover:scale-[1.04] active:scale-95"
                aria-label="Hemen Ara"
            >
                <span className="absolute inset-0 rounded-full bg-[#FF3B30] pulse-ring -z-10" />
                <Phone className="w-4 h-4" strokeWidth={2.5} />
                <span>Ara</span>
            </a>
            <a
                href={waHref}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="float-whatsapp-btn"
                className="inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1EBE5D] text-white px-4 sm:px-5 py-2.5 text-sm font-bold transition-all hover:scale-[1.04] active:scale-95"
                aria-label="WhatsApp'tan Mesaj Gönder"
            >
                <MessageCircle className="w-4 h-4" strokeWidth={2.5} />
                <span>WhatsApp</span>
            </a>
        </div>
    );
};

export default FloatingDock;
